import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Image from 'quarks/Image';
import Text from 'quarks/Text';
import type { BasicProps } from 'quarks/interpolations/basic';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentTestimonial } from 'graphqlTypes';
import type { FC } from 'react';

interface TestimonialProps extends BasicProps, ContentfulComponentTestimonial {
  backgroundIsDark: boolean;
}

const TestimonialWrapper: FC<TestimonialProps> = ({ person, testimonial, backgroundIsDark, ...props }) => (
  <Flex
    className="testimonial-card"
    flexDirection="column"
    gap="24px"
    paddingAll={24}
    backgroundColor="common-transparent"
    {...props}
  >
    {person?.company?.logo && (
      <Container width="100%" maxWidth="105px" height="38px">
        <Image
          alt={person.company.company || ''}
          image={person.company.logo}
          height="100%"
          objectFit="contain"
          objectPosition="center"
        />
      </Container>
    )}
    {testimonial && (
      <Text textStyle="textSm" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
        {richTextParser(testimonial)}
      </Text>
    )}
    {person && (
      <Flex gap="16px">
        <Container width="48px" height="48px" borderRadius="50%" overflowY="hidden" overflowX="hidden">
          {person?.headshot && <Image alt={person.name || ''} image={person.headshot} width="100%" height="100%" />}
        </Container>
        <Flex flexDirection="column">
          {person?.name && (
            <Text textStyle="textSm" fontWeight="bold" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
              {person.name}
            </Text>
          )}
          {person?.position && (
            <Text textStyle="textSm" textColor={backgroundIsDark ? 'gray-200' : 'gray-700'}>
              {person.position}
            </Text>
          )}
        </Flex>
      </Flex>
    )}
  </Flex>
);

export default TestimonialWrapper;
